"use strict";

export class AnimationCurve {
    constructor(keyframes) {
        this.keyframes = keyframes;
        this.keyframe01 = null;
        this.keyframe02 = null;
    }
    
    evaluate(t) {
        if (t < 0 || isNaN(t)) {
            t = 0;
        }

        for (let i = 0; i < this.keyframes.length - 1; i++) {
            if (t >= this.keyframes[i].time) {
                this.keyframe01 = this.keyframes[i];
            }
            if (t <= this.keyframes[i + 1].time) {
                this.keyframe02 = this.keyframes[i + 1];
            }
        }

        let tm1 = this.keyframe01.time;
        let v1 = this.keyframe01.value;
        let tg1 = this.keyframe01.outTang;
        let tm2 = this.keyframe02.time;
        let v2 = this.keyframe02.value;
        let tg2 = this.keyframe02.inTang;

        //
        // Eq1
        //
        let pd = 1/(tm2-tm1);
        let td = t-tm1;
        let ta = td*pd;
        return ((t*2 + tm1 - tm2*3)*((tg2+tg1)/2 - (v2-v1)*pd)*ta + (t + tm1 - tm2*2)*(tg2-tg1)/2)*ta + tg2*td + v1

        //
        // Eq2
        //
        // let xd = tm2-tm1;
        // t = (t-tm1)/xd;
        // return (2*t**3 - 3*t**2 + 1)*v1 + (t**3 - 2*t**2 + t)*tg1*xd + (t**3 - t**2)*tg2*xd + (-2*t**3 + 3*t**2)*v2

        //
        // Eq3
        //
        // let dt = tm2 - tm1;
        // t = (t - tm1) / dt;
        // let m0 = tg1 * dt;
        // let m1 = tg2 * dt;
        // let t2 = t * t;
        // let t3 = t2 * t;
        // let a = 2 * t3 - 3 * t2 + 1;
        // let b = t3 - 2 * t2 + t;
        // let c = t3 - t2;
        // let d = -2 * t3 + 3 * t2;
        // return a * v1 + b * m0 + c * m1 + d * v2;

        //
        // Eq4
        //
        // let e = 1/(tm2-tm1);
        // let f = e*(tg1-tg2);
        // let a = (tg1 + tg2 + 2*e*(v1-v2))*e**2;
        // let b = (a*3*(tm2+tm1) + f)/-2;
        // let c = tm2*(a*3*tm1 + f) + tg2;
        // let d = tm1/2*(a*tm1*(tm1 - tm2*3) + f*(tm1 - tm2*2) - tg2*2) + v1;
        // return t*(t**2*a + t*b + c) + d;

        //
        // Eq5
        //
        // let divisor = ((tm1 * tm1 * tm1) - (tm2 * tm2 * tm2) + (3 * tm1 * tm2 * (tm2 - tm1)));
        // let a = ((tg1 + tg2) * (tm1 - tm2) + (v2 - v1) * 2) / divisor;
        // let b = (2 * (tm2 * tm2 * tg1 - tm1 * tm1 * tg2) - tm1 * tm1 * tg1 + tm2 * tm2 * tg2 + tm1 * tm2 * (tg2 - tg1) + 3 * (tm1 + tm2) * (v1 - v2)) / divisor;
        // let c = (tm1 * tm1 * tm1 * tg2 - tm2 * tm2 * tm2 * tg1 + tm1 * tm2 * (tm1 * (2 * tg1 + tg2) - tm2 * (tg1 + 2 * tg2)) + 6 * tm1 * tm2 * (v2 - v1)) / divisor;
        // let d = ((tm1 * tm2 * tm2 - tm1 * tm1 * tm2) * (tm2 * tg1 + tm1 * tg2) - v1 * tm2 * tm2 * tm2 + tm1 * tm1 * tm1 * v2 + 3 * tm1 * tm2 * (tm2 * v1 - tm1 * v2)) / divisor;
        // return a * t * t * t + b * t * t + c * t + d;
    }
}